import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import { Controlled as CodeMirror } from "react-codemirror2";
// import prettify from 'html-prettify';
// import { CKEditor } from '../../utils/ckeditor';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import CKEditor from 'ckeditor4-react';

import {
  updateConsentRequest,
  createConsentRequest,
  getSettingsSitesRequest,
} from "../../api/requests";
import {
  getConsentCreatePermission,
  getConsentUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./SettingsConsentForm.css";
import { logout } from "../../reducers/user/actions";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const { Option } = Select;

class SettingsConsentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      content: null,
      sites: [],
      view: "html",
    };
  }

  async componentDidMount() {
    this.setState({ content: this.props.content });
    this.editorInstance.setSize("100%", "500px");

    try {
      const { data } = await getSettingsSitesRequest({});
      this.setState({ sites: data });
    } catch (e) {
      if (get(e, 'response.status') === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const consent = { ...values };
          consent.content = this.state.content;

          if (this.props.id) {
            await updateConsentRequest(this.props.id, consent);
          } else {
            await createConsentRequest(consent);
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, content, sites, view } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      consentUpdatePermission,
      consentCreatePermission,
      id,
      isNew,
    } = this.props;

    const isEditable = id ? consentUpdatePermission : consentCreatePermission;

    const appliedVal = getFieldValue("applied_to");

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.name}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              "Add consent"
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>Name:</b>
                <Form.Item>
                  {getFieldDecorator("name", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "name", ""),
                  })(<Input disabled={!isEditable} placeholder="name" />)}
                </Form.Item>
              </label>
            </Col>
            <Col lg={12}>
              <label>
                <b>Consent type:</b>
                <Form.Item>
                  {getFieldDecorator("consent_type", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "consent_type", ""),
                  })(
                    <Select>
                      <Option value="subject_form">Subject form</Option>
                      <Option value="surrogate_form">Surrogate form</Option>
                      <Option value="patient_regained_capacity_form">
                        Patient regained capacity form
                      </Option>
                      <Option value="blank_subject_form">
                        Blank subject form
                      </Option>
                      <Option value="randomization_platform_step_3_patient">
                        Randomization Platform Step 3 Patient
                      </Option>
                      <Option value="randomization_platform_step_3_patient_regained_capacity">
                        Randomization Platform Step 3 Patient Regained Capacity
                      </Option>
                      <Option value="randomization_platform_step_3_surrogate">
                        Randomization Platform Step 3 Surrogate
                      </Option>
                      <Option value="edmonton_consent_patient_form">
                        Edmonton Consent - Patient - PDF
                      </Option>
                      <Option value="edmonton_consent_patient_regained_capacity_form">
                        Edmonton Consent - Patient Regained Capacity - PDF
                      </Option>
                      <Option value="edmonton_consent_patient_withdraw_form">
                        Edmonton Consent - Patient Withdraw - PDF
                      </Option>
                      <Option value="edmonton_consent_surrogate">
                        Edmonton Consent - Surrogate - PDF
                      </Option>
                      <Option value="edmonton_consent_patient_deferred">
                        Edmonton Consent - Deferred Consent - PDF
                      </Option>
                      <Option value="edmonton_consent_patient_form_ui">
                        Edmonton Consent - Patient - UI
                      </Option>
                      <Option value="edmonton_consent_patient_regained_capacity_form_ui">
                        Edmonton Consent - Patient Regained Capacity - UI
                      </Option>
                      <Option value="edmonton_consent_patient_withdraw_form_ui">
                        Edmonton Consent - Patient Withdraw - UI
                      </Option>
                      <Option value="edmonton_consent_surrogate_ui">
                        Edmonton Consent - Surrogate - UI
                      </Option>
                      <Option value="edmonton_consent_patient_deferred_ui">
                        Edmonton Consent - Deferred Consent - UI
                      </Option>
                      <Option value="sunnybrook_consent_patient_form_pdf">
                        Sunnybrook - Patient - PDF
                      </Option>
                      <Option value="sunnybrook_consent_patient_regained_capacity_form_pdf">
                        Sunnybrook - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="sunnybrook_consent_surrogate_pdf">
                        Sunnybrook - Surrogate - PDF
                      </Option>
                      <Option value="sunnybrook_consent_patient_form_ui">
                        Sunnybrook - Patient - UI
                      </Option>
                      <Option value="sunnybrook_consent_patient_regained_capacity_form_ui">
                        Sunnybrook - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="sunnybrook_consent_surrogate_ui">
                        Sunnybrook - Surrogate - UI
                      </Option>
                      <Option value="toronto_uh_consent_patient_form_pdf">
                        Toronto UH - Patient - PDF
                      </Option>
                      <Option value="toronto_uh_consent_patient_regained_capacity_form_pdf">
                        Toronto UH - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="toronto_uh_consent_surrogate_pdf">
                        Toronto UH - Surrogate - PDF
                      </Option>
                      <Option value="toronto_uh_consent_patient_form_ui">
                        Toronto UH - Patient - UI
                      </Option>
                      <Option value="toronto_uh_consent_patient_regained_capacity_form_ui">
                        Toronto UH - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="toronto_uh_consent_surrogate_ui">
                        Toronto UH - Surrogate - UI
                      </Option>
                      <Option value="montreal_consent_patient_form_pdf">
                        Montreal - Patient / Surrogate - PDF
                      </Option>
                      <Option value="montreal_consent_patient_form_ui">
                        Montreal - Patient / Surrogate - UI
                      </Option>
                      <Option value="winnipeg_consent_patient_form_pdf">
                        Winnipeg - Patient - PDF
                      </Option>
                      <Option value="winnipeg_consent_patient_regained_capacity_form_pdf">
                        Winnipeg - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="winnipeg_consent_surrogate_pdf">
                        Winnipeg - Surrogate - PDF
                      </Option>
                      <Option value="winnipeg_consent_substudy_form_pdf">
                        Winnipeg - Patient / Surrogate - Substudy - PDF
                      </Option>
                      <Option value="winnipeg_consent_patient_form_ui">
                        Winnipeg - Patient - UI
                      </Option>
                      <Option value="winnipeg_consent_patient_regained_capacity_form_ui">
                        Winnipeg Consent - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="winnipeg_consent_surrogate_ui">
                        Winnipeg Consent - Surrogate - UI
                      </Option>
                      <Option value="winnipeg_consent_substudy_form_ui">
                        Winnipeg Consent - Patient / Surrogate - Substudy - UI
                      </Option>
                      <Option value="uhn_consent_patient_form_pdf">
                        UHN - Patient - PDF
                      </Option>
                      <Option value="uhn_consent_patient_regained_capacity_form_pdf">
                        UHN - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="uhn_consent_surrogate_pdf">
                        UHN - Surrogate - PDF
                      </Option>
                      <Option value="uhn_consent_patient_form_ui">
                        UHN - Patient - UI
                      </Option>
                      <Option value="uhn_consent_patient_regained_capacity_form_ui">
                        UHN - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="uhn_consent_surrogate_ui">
                        UHN - Surrogate - UI
                      </Option>
                      <Option value="halifax_consent_patient_form_pdf">
                        Halifax - Patient - PDF
                      </Option>
                      <Option value="halifax_consent_patient_regained_capacity_form_pdf">
                        Halifax - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="halifax_consent_surrogate_pdf">
                        Halifax - Surrogate - PDF
                      </Option>
                      <Option value="halifax_consent_patient_form_ui">
                        Halifax - Patient - UI
                      </Option>
                      <Option value="halifax_consent_patient_regained_capacity_form_ui">
                        Halifax - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="halifax_consent_surrogate_ui">
                        Halifax - Surrogate - UI
                      </Option>
                      <Option value="pei_consent_patient_form_pdf">
                        Pei - Patient - PDF
                      </Option>
                      <Option value="pei_consent_patient_regained_capacity_form_pdf">
                        Pei - Patient - Regained Capacity - PDF
                      </Option>
                      <Option value="pei_consent_surrogate_pdf">
                        Pei - Surrogate - PDF
                      </Option>
                      <Option value="pei_consent_patient_form_ui">
                        Pei - Patient - UI
                      </Option>
                      <Option value="pei_consent_patient_regained_capacity_form_ui">
                        Pei - Patient - Regained Capacity - UI
                      </Option>
                      <Option value="pei_consent_surrogate_ui">
                        Pei - Surrogate - UI
                      </Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>Applied to:</b>
                <Form.Item>
                  {getFieldDecorator("applied_to", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "applied_to", ""),
                  })(
                    <Select>
                      <Option value="all_sites">All sites</Option>
                      <Option value="site">Site</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            {appliedVal === "site" && (
              <Col lg={12}>
                <label>
                  <b>Site ID</b>
                  <Form.Item>
                    {getFieldDecorator("site_id", {
                      rules: [{ required: true, message: "Required" }],
                      initialValue: get(this.props, "site_id"),
                    })(
                      <Select
                        placeholder="Select Site ID"
                        style={{ width: "100%" }}
                        allowClear
                      >
                        {sites.map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          </Row>

          <div style={{ marginBottom: "30px" }}>
            <Button
              type="primary"
              size="large"
              onClick={() => {
                this.setState((state) => ({
                  view: state.view === "html" ? "preview" : "html",
                }));
              }}
            >
              Switch to {view === "html" ? "Preview" : "Code"}
            </Button>
          </div>

          <Row gutter={12} style={{ display: view === "html" ? 'block' : 'none' }}>
            <Col>
              <div style={{ marginBottom: "20px" }}>
                <CodeMirror
                  editorDidMount={(editor) => {
                    this.editorInstance = editor;
                  }}
                  value={content}
                  onBeforeChange={(editor, data, value) => {
                    this.setState({ content: value });
                  }}
                  options={{
                    mode: "html",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </div>
            </Col>
          </Row>

          {view === "preview" && <Row gutter={12}>
            <Col>
              <h3 className='headline-default'>Preview</h3>
              <iframe
                id="previewFrame"
                onLoad={() => {
                  const iFrameID = document.getElementById('previewFrame');
                  console.log(iFrameID);
                  if(iFrameID) {
                    iFrameID.height = "";
                    iFrameID.height = iFrameID.contentWindow.document.body.scrollHeight + 60 + "px";
                  }
                }}
                srcDoc={
                  content
                    ? content
                        .replace(/src="{{(.*)}}/g, 'src="{{$1}}" alt="$1"')
                        .replace(/src={{(.*)}}/g, 'src="{{$1}}" alt="$1"')
                        .replace(/margin-left: -15px/g, '')
                        .replace(
                          /static\/images/g,
                          "https://act-staging-api.dctms.ca/static/images"
                        )
                        .replace(
                          /url\(\"static/g,
                          'url("https://act-staging-api.dctms.ca/static'
                        )
                    : ""
                }
                className={classes.previewFrame}
              />
            </Col>
          </Row>}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            )}
            &nbsp; &nbsp;
            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentCreatePermission: getConsentCreatePermission(state),
  consentUpdatePermission: getConsentUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "consent" })(
  connect(mapStateToProps, mapDispatchToProps)(SettingsConsentForm)
);



// WEBPACK FOOTER //
// ./src/components/SettingsConsentForm/SettingsConsentForm.js